import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "query", "form" ]

  submit(event) {
    event.preventDefault();
    window.Turbo.visit(`${this.search_url}/${this.query}`);
  }

  // private

  get query() {
    return this.queryTarget.value
  }
  get search_url() {
    return this.formTarget.action
  }
}